// extracted by mini-css-extract-plugin
export default {"waTemplate":"TemplateAnlegen_waTemplate__StyZk","cardMedia":"TemplateAnlegen_cardMedia__I6O3n"};